// extracted by mini-css-extract-plugin
export default {"companyContainer":"SV-z","companyImage":"TV-z","container":"UV-z","heading":"VV-z","darkText":"WV-z","smallHeading":"XV-z","darkBackground":"YV-z","whiteBackground":"ZV-z"};